{
  "name": "@aws-sdk/client-sesv2",
  "version": "3.1091.0",
  "description": "AWS SDK for JavaScript Sesv2 Client for Node.js, Browser and React Native",
  "homepage": "https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-sesv2",
  "license": "Apache-2.0",
  "author": {
    "name": "AWS SDK for JavaScript Team",
    "url": "https://aws.amazon.com/sdk-for-javascript/"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/aws/aws-sdk-js-v3.git",
    "directory": "clients/client-sesv2"
  },
  "files": [
    "dist-*/**"
  ],
  "sideEffects": false,
  "main": "./dist-cjs/index.js",
  "module": "./dist-es/index.js",
  "browser": {
    "./dist-es/runtimeConfig": "./dist-es/runtimeConfig.browser"
  },
  "types": "./dist-types/index.d.ts",
  "typesVersions": {
    "<4.5": {
      "dist-types/*": [
        "dist-types/ts3.4/*"
      ]
    }
  },
  "react-native": {
    "./dist-es/runtimeConfig": "./dist-es/runtimeConfig.native"
  },
  "scripts": {
    "build": "concurrently 'yarn:build:types' 'yarn:build:es' && yarn build:cjs",
    "build:cjs": "node ../../scripts/compilation/inline",
    "build:es": "premove dist-es && tsc -p tsconfig.es.json",
    "build:include:deps": "yarn g:turbo run build -F=\"$npm_package_name\"",
    "build:types": "premove dist-types && tsc -p tsconfig.types.json",
    "build:types:downlevel": "downlevel-dts dist-types dist-types/ts3.4",
    "clean": "premove dist-cjs dist-es dist-types",
    "extract:docs": "api-extractor run --local",
    "generate:client": "node ../../scripts/generate-clients/single-service",
    "test:index": "tsc --noEmit ./test/index-types.ts && node ./test/index-objects.spec.mjs"
  },
  "dependencies": {
    "@aws-sdk/core": "^3.975.3",
    "@aws-sdk/credential-provider-node": "^3.972.70",
    "@aws-sdk/signature-v4-multi-region": "^3.996.41",
    "@aws-sdk/types": "^3.974.2",
    "@smithy/core": "^3.29.4",
    "@smithy/fetch-http-handler": "^5.6.6",
    "@smithy/node-http-handler": "^4.9.6",
    "@smithy/types": "^4.16.1",
    "tslib": "^2.6.2"
  },
  "devDependencies": {
    "@tsconfig/node20": "20.1.8",
    "@types/node": "^20.14.8",
    "concurrently": "7.0.0",
    "downlevel-dts": "0.10.1",
    "premove": "4.0.0",
    "typescript": "~5.8.3"
  },
  "engines": {
    "node": ">=20.0.0"
  }
}
